import { render, staticRenderFns } from "./SupplierWithCreate.vue?vue&type=template&id=00a4487e&"
import script from "./SupplierWithCreate.vue?vue&type=script&lang=js&"
export * from "./SupplierWithCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports